import { Icon, SegmentedCard } from '@smartgift/frontend-toolkit';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { NEW_CONTACTS_TAB } from '@hero/constants';

function SelectAddingType({ setActiveScene, onRequestClose, setFooterProps, setModalHeader }) {
  const { t } = useTranslation();

  const hash = decodeURIComponent(location.hash.slice(1));
  const defaultActiveTab =
    Object.values(NEW_CONTACTS_TAB).find(o => o === hash) || NEW_CONTACTS_TAB.individual;
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const newContactOptions = [
    {
      value: NEW_CONTACTS_TAB.individual,
      title: t('individually'),
      icon: <Icon name="add-contact" size="xl" />,
      hiddenInput: false,
      description: t('individuallyDesc')
    },
    {
      value: NEW_CONTACTS_TAB.bulkImport,
      title: t('bulkImport'),
      icon: <Icon name="contacts" size="xl" />,
      hiddenInput: false,
      description: t('bulkImportDesc')
    }
  ];

  useEffect(() => {
    setModalHeader({
      title: t('howWouldYouLikeToAddContacts')
    });

    setFooterProps({
      leftButtonText: t('cancel'),
      leftButtonOnClick: () => onRequestClose(),
      isLeftButtonActive: true,
      rightButtonText: t('next'),
      rightButtonOnClick: () => {
        setActiveScene(activeTab);
      },
      isRightButtonActive: !!activeTab,
      rightButtonEndIcon: <Icon name="next" />
    });
  }, [activeTab]);

  return (
    <SegmentedCard
      updateHash={false}
      activeTab={activeTab}
      onChange={setActiveTab}
      options={newContactOptions}
    />
  );
}

export { SelectAddingType };
